"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _initializerDefineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/initializerDefineProperty"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _applyDecoratedDescriptor2 = _interopRequireDefault(require("@babel/runtime/helpers/applyDecoratedDescriptor"));
var _initializerWarningHelper2 = _interopRequireDefault(require("@babel/runtime/helpers/initializerWarningHelper"));
var _mobx = require("mobx");
var _mobxUtils = require("mobx-utils");
var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));
var _selectFilter = require("../../../utils/filters/select-filter.utils");
var _nestedSelect = require("../../../utils/filters/nested-select.utils");
var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4;
var NestedSelectFilter = exports.default = (_dec = _mobx.observable.shallow, _dec2 = _mobx.observable.shallow, _dec3 = _mobx.observable.shallow, _dec4 = _mobx.action.bound, _dec5 = _mobx.action.bound, _dec6 = _mobx.action.bound, _dec7 = _mobx.action.bound, _dec8 = _mobx.action.bound, _dec9 = _mobx.action.bound, _dec10 = _mobx.action.bound, _dec11 = _mobx.action.bound, (_class = function () {
  function NestedSelectFilter($env) {
    var _this = this;
    (0, _classCallCheck2.default)(this, NestedSelectFilter);
    this.$env = void 0;
    this.id = "nested-select";
    (0, _initializerDefineProperty2.default)(this, "data", _descriptor, this);
    (0, _initializerDefineProperty2.default)(this, "state", _descriptor2, this);
    (0, _initializerDefineProperty2.default)(this, "uncommittedState", _descriptor3, this);
    (0, _initializerDefineProperty2.default)(this, "isTouched", _descriptor4, this);
    this.isOriginPristine = (0, _mobxUtils.computedFn)(function (index) {
      var _this$state$index;
      return (0, _selectFilter.isSelectFilterStatePristine)((_this$state$index = _this.state[index]) === null || _this$state$index === void 0 ? void 0 : _this$state$index.origin);
    });
    this.isDestinationPristine = (0, _mobxUtils.computedFn)(function (index) {
      var _this$state$index2;
      return (0, _selectFilter.isSelectFilterStatePristine)((_this$state$index2 = _this.state[index]) === null || _this$state$index2 === void 0 ? void 0 : _this$state$index2.destination);
    });
    this.isOriginUncommitted = (0, _mobxUtils.computedFn)(function (index) {
      var _this$uncommittedStat, _this$state$index3;
      return (0, _selectFilter.isSelectFilterStateUncommitted)((_this$uncommittedStat = _this.uncommittedState[index]) === null || _this$uncommittedStat === void 0 ? void 0 : _this$uncommittedStat.origin, (_this$state$index3 = _this.state[index]) === null || _this$state$index3 === void 0 ? void 0 : _this$state$index3.origin);
    });
    this.isDestinationUncommitted = (0, _mobxUtils.computedFn)(function (index) {
      var _this$uncommittedStat2, _this$state$index4;
      return (0, _selectFilter.isSelectFilterStateUncommitted)((_this$uncommittedStat2 = _this.uncommittedState[index]) === null || _this$uncommittedStat2 === void 0 ? void 0 : _this$uncommittedStat2.destination, (_this$state$index4 = _this.state[index]) === null || _this$state$index4 === void 0 ? void 0 : _this$state$index4.destination);
    });
    this.isOriginDirty = (0, _mobxUtils.computedFn)(function (index) {
      return !_this.isOriginPristine(index) || _this.isOriginUncommitted(index);
    });
    this.isDestinationDirty = (0, _mobxUtils.computedFn)(function (index) {
      return !_this.isDestinationPristine(index) || _this.isDestinationUncommitted(index);
    });
    this.$env = $env;
  }
  (0, _createClass2.default)(NestedSelectFilter, [{
    key: "query",
    get: function get() {
      return (0, _nestedSelect.getNestedSelectFilterQuery)(this.params);
    }
  }, {
    key: "params",
    get: function get() {
      return (0, _nestedSelect.getNestedSelectFilterParams)(this.state);
    }
  }, {
    key: "isDirty",
    get: function get() {
      return !this.isPristine || this.isUncommitted;
    }
  }, {
    key: "isPristine",
    get: function get() {
      return (0, _nestedSelect.isNestedSelectStatePristine)(this.state);
    }
  }, {
    key: "isUncommitted",
    get: function get() {
      return (0, _nestedSelect.isNestedSelectStateUncommitted)(this.uncommittedState, this.state);
    }
  }, {
    key: "isReady",
    get: function get() {
      return !(0, _isEmpty2.default)(this.data);
    }
  }, {
    key: "filter",
    value: function filter(itineraryFilterData) {
      return (0, _nestedSelect.filterNestedSelectFilter)(this.params, itineraryFilterData);
    }
  }, {
    key: "initialize",
    value: function initialize(data, query, withCommit) {
      if (query === void 0) {
        query = "";
      }
      if (withCommit === void 0) {
        withCommit = true;
      }
      this.data = data;
      if (withCommit) {
        this.state = this.uncommittedState;
      }
      if (query) {
        this.update(query, withCommit);
      }
    }
  }, {
    key: "toggle",
    value: function toggle(payload, withCommit) {
      if (withCommit === void 0) {
        withCommit = false;
      }
      this.uncommittedState = (0, _nestedSelect.toggleNestedSelectState)(this.uncommittedState, payload);
      withCommit && this.commit();
    }
  }, {
    key: "update",
    value: function update(query, withCommit) {
      if (withCommit === void 0) {
        withCommit = false;
      }
      if (!query) {
        this.reset(withCommit);
      } else {
        this.uncommittedState = (0, _nestedSelect.updateNestedSelectState)(this.uncommittedState, query);
        withCommit && this.commit();
      }
    }
  }, {
    key: "commit",
    value: function commit() {
      this.state = this.uncommittedState;
      this.isTouched = true;
    }
  }, {
    key: "revert",
    value: function revert() {
      this.uncommittedState = this.state;
    }
  }, {
    key: "reset",
    value: function reset(withCommit) {
      if (withCommit === void 0) {
        withCommit = false;
      }
      this.initialize(this.data, undefined, withCommit);
    }
  }, {
    key: "clone",
    value: function clone(filterState) {
      this.uncommittedState = filterState;
      this.commit();
    }
  }]);
  return NestedSelectFilter;
}(), (_descriptor = (0, _applyDecoratedDescriptor2.default)(_class.prototype, "data", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor2 = (0, _applyDecoratedDescriptor2.default)(_class.prototype, "state", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor3 = (0, _applyDecoratedDescriptor2.default)(_class.prototype, "uncommittedState", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor4 = (0, _applyDecoratedDescriptor2.default)(_class.prototype, "isTouched", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "query", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "query"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "params", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "params"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "isDirty", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "isDirty"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "isPristine", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "isPristine"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "isUncommitted", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "isUncommitted"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "isReady", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "isReady"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "filter", [_dec4], Object.getOwnPropertyDescriptor(_class.prototype, "filter"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "initialize", [_dec5], Object.getOwnPropertyDescriptor(_class.prototype, "initialize"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "toggle", [_dec6], Object.getOwnPropertyDescriptor(_class.prototype, "toggle"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "update", [_dec7], Object.getOwnPropertyDescriptor(_class.prototype, "update"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "commit", [_dec8], Object.getOwnPropertyDescriptor(_class.prototype, "commit"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "revert", [_dec9], Object.getOwnPropertyDescriptor(_class.prototype, "revert"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "reset", [_dec10], Object.getOwnPropertyDescriptor(_class.prototype, "reset"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "clone", [_dec11], Object.getOwnPropertyDescriptor(_class.prototype, "clone"), _class.prototype)), _class));